// extracted by mini-css-extract-plugin
export default {"headingText":"NewGuest_headingText__YRM99","btnRow":"NewGuest_btnRow__W91RW","dropBtn":"NewGuest_dropBtn__nQqAx","btn":"NewGuest_btn__JASOE","groupCont":"NewGuest_groupCont__Ry9ny"};